var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 796,
    viewBox: "0 0 1440 796",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_25521)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 796,
    fill: "#2537A8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 1343.3,
    height: 1343.3,
    rx: 70,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 490.539 -551.708)",
    fill: "url(#paint0_linear_15_25521)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.707107,
    width: 1342.3,
    height: 1342.3,
    rx: 69.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 490.039 -551.793)",
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 1343.3,
    height: 1343.3,
    rx: 70,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 76.9771 -551.708)",
    fill: "url(#paint1_linear_15_25521)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.707107,
    width: 1342.3,
    height: 1342.3,
    rx: 69.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 76.4771 -551.793)",
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 1343.3,
    height: 1343.3,
    rx: 70,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 -336.584 -551.708)",
    fill: "url(#paint2_linear_15_25521)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.707107,
    width: 1342.3,
    height: 1342.3,
    rx: 69.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 -337.084 -551.793)",
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 1343.3,
    height: 1343.3,
    rx: 70,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 -750.146 -552)",
    fill: "url(#paint3_linear_15_25521)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.707107,
    width: 1342.3,
    height: 1342.3,
    rx: 69.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 -750.646 -551.793)",
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.5,
    y: 60.5,
    width: 45,
    height: 45,
    rx: 7.5,
    fill: "url(#paint4_linear_15_25521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.419 75.65L295.617 92.4519C295.426 92.6434 295.172 92.7422 294.919 92.7422C294.666 92.7422 294.413 92.6457 294.22 92.4526L285.325 83.5575C284.939 83.1714 284.939 82.5457 285.325 82.1602C285.711 81.7748 286.337 81.7741 286.723 82.1602L294.919 90.3578L311.023 74.2539C311.409 73.8678 312.035 73.8678 312.42 74.2539C312.806 74.64 312.808 75.267 312.419 75.65Z",
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.5,
    y: 60.5,
    width: 45,
    height: 45,
    rx: 7.5,
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.5,
    y: 60.5,
    width: 45,
    height: 45,
    rx: 7.5,
    fill: "#2537A8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15_25521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M700.5 88.25H698.75C697.784 88.25 697 89.0337 697 90V95.25C697 96.2163 697.784 97 698.75 97H700.5C701.466 97 702.25 96.2163 702.25 95.25V90C702.25 89.032 701.466 88.25 700.5 88.25ZM700.5 95.25H698.75V90H700.5V95.25ZM726.75 79.5H725C724.034 79.5 723.25 80.2837 723.25 81.25V95.25C723.25 96.2163 724.034 97 725 97H726.75C727.716 97 728.5 96.2163 728.5 95.25V81.25C728.5 80.282 727.718 79.5 726.75 79.5ZM726.75 95.25H725V81.25H726.75V95.25ZM718 86.5H716.25C715.284 86.5 714.5 87.2837 714.5 88.25V95.25C714.5 96.2163 715.284 97 716.25 97H718C718.966 97 719.75 96.2163 719.75 95.25V88.25C719.75 87.282 718.968 86.5 718 86.5ZM718 95.25H716.25V88.25H718V95.25ZM709.25 79.5H707.5C706.532 79.5 705.75 80.282 705.75 81.25V95.25C705.75 96.2163 706.534 97 707.5 97H709.25C710.216 97 711 96.2163 711 95.25V81.25C711 80.282 710.218 79.5 709.25 79.5ZM709.25 95.25H707.5V81.25H709.25V95.25ZM724.623 73.8781C724.951 74.0925 725.41 74.25 725.875 74.25C727.324 74.25 728.5 73.0748 728.5 71.625C728.5 70.1752 727.324 69 725.875 69C724.426 69 723.25 70.1752 723.25 71.625C723.25 71.9618 723.336 72.2714 723.455 72.5656L718.377 76.3719C718 76.1586 717.59 76 717.125 76C716.66 76 716.247 76.1573 715.87 76.3719L710.798 72.5656C710.913 72.2714 711 71.9619 711 71.625C711 70.1752 709.824 69 708.375 69C706.926 69 705.75 70.1752 705.75 71.625C705.75 72.0272 705.868 72.3923 706.031 72.7319L700.732 78.0305C700.392 77.8703 700.027 77.75 699.625 77.75C698.175 77.75 697 78.9258 697 80.375C697 81.8242 698.175 83 699.625 83C701.075 83 702.25 81.8242 702.25 80.375C702.25 79.9728 702.132 79.6077 701.969 79.2681L707.268 73.9695C707.56 74.1324 707.97 74.25 708.375 74.25C708.84 74.25 709.253 74.0927 709.63 73.8781L714.705 77.6843C714.587 77.9797 714.5 78.2859 714.5 78.625C714.5 80.0742 715.676 81.25 717.125 81.25C718.574 81.25 719.75 80.0742 719.75 78.625C719.75 78.2882 719.664 77.9786 719.545 77.6844L724.623 73.8781ZM725.875 70.75C726.356 70.75 726.75 71.1427 726.75 71.625C726.75 72.1073 726.356 72.5 725.875 72.5C725.612 72.5 725.417 72.3755 725.3 72.2711L725.194 72.1767L725.119 72.0418C725.038 71.8979 725 71.7617 725 71.625C725 71.1427 725.394 70.75 725.875 70.75ZM699.625 81.25C699.143 81.25 698.75 80.8562 698.75 80.375C698.75 79.8938 699.143 79.5 699.625 79.5C699.805 79.5 699.974 79.5555 700.127 79.6648L700.249 79.7512L700.335 79.8726C700.445 80.025 700.5 80.1945 700.5 80.375C700.5 80.8562 700.107 81.25 699.625 81.25ZM709.13 72.0417L709.059 72.1768L708.949 72.2714C708.834 72.3753 708.637 72.5 708.375 72.5C708.195 72.5 708.025 72.4448 707.872 72.3354L707.752 72.249L707.664 72.1276C707.555 71.9739 707.5 71.8049 707.5 71.625C707.5 71.1427 707.894 70.75 708.375 70.75C708.856 70.75 709.25 71.1427 709.25 71.625C709.25 71.7617 709.212 71.8979 709.13 72.0417ZM717.125 79.5C716.644 79.5 716.25 79.1062 716.25 78.625C716.25 78.4885 716.289 78.3521 716.369 78.2081L716.444 78.0732L716.55 77.9789C716.666 77.8758 716.862 77.75 717.125 77.75C717.388 77.75 717.583 77.8745 717.7 77.9789L717.806 78.0733L717.881 78.2082C717.962 78.3516 718 78.4883 718 78.625C718 79.1062 717.606 79.5 717.125 79.5Z",
    fill: "#1DE9B6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 690.5,
    y: 60.5,
    width: 45,
    height: 45,
    rx: 7.5,
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.5,
    y: 156.5,
    width: 55,
    height: 55,
    rx: 7.5,
    fill: "#2537A8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_15_25521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1236.4 176.342L1230.16 170.102C1229.46 169.395 1228.51 169 1227.51 169H1218.75C1216.68 169 1215 170.679 1215 172.75L1215 195.25C1215 197.321 1216.68 199 1218.75 199H1233.75C1235.82 199 1237.5 197.321 1237.5 195.25V178.99C1237.5 177.994 1237.11 177.045 1236.4 176.342ZM1228.12 170.997C1228.39 171.089 1228.63 171.222 1228.84 171.425L1235.08 177.665C1235.28 177.865 1235.41 178.111 1235.5 178.375H1229.06C1228.55 178.375 1228.12 177.953 1228.12 177.438V170.997ZM1235.62 195.25C1235.62 196.284 1234.78 197.125 1233.75 197.125H1218.75C1217.72 197.125 1216.88 196.284 1216.88 195.25V172.75C1216.88 171.716 1217.72 170.875 1218.75 170.875H1226.25V177.438C1226.25 178.99 1227.51 180.25 1229.06 180.25H1235.62V195.25ZM1220.62 189.625C1220.11 189.625 1219.69 190.044 1219.69 190.562V194.312C1219.69 194.828 1220.11 195.25 1220.62 195.25C1221.14 195.25 1221.56 194.831 1221.56 194.312V190.562C1221.56 190.047 1221.14 189.625 1220.62 189.625ZM1226.25 182.125C1225.73 182.125 1225.31 182.547 1225.31 183.062V194.312C1225.31 194.831 1225.73 195.25 1226.25 195.25C1226.77 195.25 1227.19 194.831 1227.19 194.312V183.062C1227.19 182.547 1226.77 182.125 1226.25 182.125ZM1231.88 195.25C1232.39 195.25 1232.81 194.831 1232.81 194.312V186.812C1232.81 186.297 1232.39 185.875 1231.88 185.875C1231.36 185.875 1230.94 186.294 1230.94 186.812V194.312C1230.94 194.828 1231.36 195.25 1231.88 195.25Z",
    fill: "#1DE9B6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1198.5,
    y: 156.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.5,
    y: 680.5,
    width: 55,
    height: 55,
    rx: 7.5,
    fill: "#2537A8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_15_25521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728 710H720C718.344 710 717 711.344 717 713V721C717 722.657 718.343 724 720 724H728C729.657 724 731 722.657 731 721V713C731 711.344 729.656 710 728 710ZM729 721C729 721.551 728.551 722 728 722H720C719.449 722 719 721.551 719 721V713C719 712.449 719.449 712 720 712H728C728.551 712 729 712.449 729 713V721ZM714 716H710C708.344 716 707 714.656 707 713V706H710C711.656 706 713 704.656 713 703V695C713 693.343 711.656 692 710 692H702C700.343 692 699 693.343 699 695V703C699 704.656 700.343 706 702 706H705V713C705 715.756 707.244 718 710 718H714C714.553 718 715 717.553 715 717C715 716.447 714.55 716 714 716ZM702 704C701.449 704 701 703.55 701 703V695C701 694.449 701.449 694 702 694H710C710.55 694 711 694.449 711 695V703C711 703.55 710.55 704 710 704H702Z",
    fill: "#1DE9B6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 687.5,
    y: 680.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 963.5,
    y: 370.5,
    width: 55,
    height: 55,
    rx: 7.5,
    fill: "#2537A8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_15_25521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M982.75 401.5C985.65 401.5 988 399.15 988 396.25C988 393.35 985.65 391 982.75 391C979.802 391 977.5 393.302 977.5 396.25C977.5 399.148 979.802 401.5 982.75 401.5ZM982.75 392.75C984.68 392.75 986.25 394.32 986.25 396.25C986.25 398.18 984.68 399.75 982.75 399.75C980.82 399.75 979.25 398.18 979.25 396.25C979.25 394.32 980.82 392.75 982.75 392.75ZM1006.38 384H985.375C983.926 384 982.75 385.177 982.75 386.625V388.375C982.75 388.858 983.144 389.25 983.625 389.25C984.106 389.25 984.5 388.858 984.5 388.375V386.625C984.5 386.143 984.894 385.75 985.375 385.75H1006.38C1006.86 385.75 1007.25 386.143 1007.25 386.625V404.125C1007.25 404.607 1006.86 405 1006.38 405H993.25C992.766 405 992.375 405.391 992.375 405.875C992.375 406.359 992.769 406.75 993.25 406.75H1006.38C1007.82 406.75 1009 405.574 1009 404.125V386.625C1009 385.177 1007.82 384 1006.38 384ZM984.5 403.25H981C977.134 403.25 974 406.384 974 410.25C974 411.216 974.784 412 975.75 412H989.75C990.716 412 991.5 411.216 991.5 410.25C991.5 406.384 988.366 403.25 984.5 403.25ZM975.75 410.25C975.75 407.355 978.105 405 981 405H984.5C987.395 405 989.75 407.355 989.75 410.25H975.75ZM991.243 393.007C990.901 392.665 990.347 392.665 990.006 393.007C989.665 393.349 989.664 393.903 990.006 394.244L994.381 398.619C994.552 398.788 994.776 398.875 995 398.875C995.224 398.875 995.448 398.79 995.619 398.619L1001.12 393.111V396.25C1001.12 396.734 1001.52 397.125 1002 397.125C1002.48 397.125 1002.88 396.734 1002.88 396.25V391C1002.88 390.516 1002.48 390.125 1002 390.125H996.75C996.266 390.125 995.875 390.516 995.875 391C995.875 391.484 996.266 391.875 996.75 391.875H999.888L995 396.764L991.243 393.007Z",
    fill: "#1DE9B6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 963.5,
    y: 370.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1141.5,
    y: 640.5,
    width: 55,
    height: 55,
    rx: 7.5,
    fill: "#2537A8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_15_25521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1153.75 667.062C1152.09 667.062 1150 668.342 1150 670.812C1150 672.878 1151.68 674.562 1153.75 674.562C1155.82 674.562 1157.5 672.878 1157.5 670.812C1157.5 668.357 1155.43 667.062 1153.75 667.062ZM1153.75 672.688C1152.72 672.688 1151.88 671.845 1151.88 670.812C1151.88 669.78 1152.72 668.938 1153.75 668.938C1154.78 668.938 1155.62 669.78 1155.62 670.812C1155.62 671.845 1154.78 672.688 1153.75 672.688ZM1160.78 669.875H1159.79C1159.33 669.875 1158.91 670.297 1158.91 670.76C1158.91 671.223 1159.33 671.75 1159.79 671.75H1160.73C1161.3 671.75 1161.72 671.328 1161.72 670.812C1161.72 670.297 1161.3 669.875 1160.78 669.875ZM1183.75 664.25C1185.41 664.25 1187.5 662.97 1187.5 660.5C1187.5 658.038 1185.41 656.75 1183.75 656.75C1182.09 656.75 1180 658.03 1180 660.5C1180 662.568 1181.69 664.25 1183.75 664.25ZM1183.75 658.625C1184.78 658.625 1185.62 659.468 1185.62 660.5C1185.62 661.532 1184.78 662.375 1183.75 662.375C1182.72 662.375 1181.88 661.532 1181.88 660.5C1181.88 659.468 1182.72 658.625 1183.75 658.625ZM1183.75 675.5C1182.97 675.5 1182.25 675.734 1181.66 676.138C1181.46 676.269 1181.28 676.416 1181.12 676.577L1175.74 673.347C1176.07 672.57 1176.25 671.709 1176.25 670.812C1176.25 667.186 1173.31 664.25 1169.69 664.25C1169.03 664.25 1168.41 664.382 1167.8 664.558L1165.5 659.627C1166.34 658.941 1166.88 657.915 1166.88 656.75C1166.88 654.293 1164.81 653 1163.12 653C1160.67 653 1159.38 655.069 1159.38 656.75C1159.38 658.815 1161.06 660.5 1163.12 660.5C1163.36 660.5 1163.59 660.471 1163.81 660.427L1166.1 665.327C1164.31 666.5 1163.12 668.516 1163.12 670.812C1163.12 674.438 1166.06 677.375 1169.69 677.375C1171.74 677.375 1173.54 676.415 1174.75 674.943L1180.16 678.188C1180.06 678.535 1180 678.887 1180 679.25C1180 681.315 1181.68 683 1183.75 683C1186.22 683 1187.5 680.914 1187.5 679.25C1187.5 677.639 1186.23 675.5 1183.75 675.5ZM1163.12 658.625C1162.09 658.625 1161.25 657.783 1161.25 656.75C1161.25 655.717 1162.09 654.875 1163.12 654.875C1164.16 654.875 1165 655.718 1165 656.75C1165 657.782 1164.16 658.625 1163.12 658.625ZM1169.69 675.5C1167.1 675.5 1165 673.396 1165 670.812C1165 668.229 1167.1 666.125 1169.69 666.125C1172.27 666.125 1174.38 668.229 1174.38 670.812C1174.38 673.396 1172.27 675.5 1169.69 675.5ZM1183.75 681.125C1182.72 681.125 1181.88 680.282 1181.88 679.25C1181.88 678.218 1182.72 677.375 1183.75 677.375C1184.78 677.375 1185.62 678.218 1185.62 679.25C1185.62 680.282 1184.78 681.125 1183.75 681.125ZM1178.03 666.43L1179.35 665.444C1179.76 665.133 1179.84 664.544 1179.53 664.13C1179.22 663.719 1178.64 663.636 1178.22 663.946L1176.91 664.932C1176.49 665.243 1176.41 665.831 1176.72 666.244C1177.03 666.658 1177.62 666.74 1178.03 666.43Z",
    fill: "#1DE9B6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1141.5,
    y: 640.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 446.5,
    width: 55,
    height: 55,
    rx: 7.5,
    fill: "#2537A8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_15_25521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.768 487.404H110.608C108.752 487.404 107.243 485.897 107.243 484.039V459.365C107.243 458.745 106.741 458.243 106.122 458.243C105.502 458.243 105 458.745 105 459.365V484.039C105 487.13 107.515 489.647 110.608 489.647H139.768C140.388 489.647 140.89 489.145 140.89 488.525C140.89 487.905 140.385 487.404 139.768 487.404ZM113.643 478.102L120.702 471.043L126.638 476.98C127.077 477.418 127.787 477.418 128.224 476.98L136.404 468.8V475.067C136.404 475.683 136.908 476.188 137.525 476.188C138.142 476.188 138.647 475.683 138.647 475.067V466.094C138.647 465.477 138.142 464.973 137.525 464.973H128.616C127.936 464.973 127.431 465.477 127.431 466.094C127.431 466.711 127.936 467.216 128.553 467.216H134.818L127.431 474.604L121.494 468.667C121.056 468.229 120.346 468.229 119.908 468.667L112.057 476.518C111.619 476.956 111.619 477.666 112.057 478.103C112.493 478.543 113.208 478.543 113.643 478.102Z",
    fill: "#1CEAB6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 446.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.5,
    y: 680.5,
    width: 55,
    height: 55,
    rx: 7.5,
    fill: "#2537A8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_15_25521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.795 709.875L307.158 709.875C306.323 709.875 305.905 710.885 306.496 711.475L314.154 719.133C314.423 719.403 315.002 719.593 315.457 719.176C317.719 717.038 319.279 714.159 319.741 710.921C319.82 710.367 319.357 709.875 318.795 709.875ZM314.822 717.146L309.42 711.75H317.676C317.201 713.748 316.211 715.617 314.822 717.146ZM301 709.875V695.974C301 695.454 300.583 695.021 300.078 695.021C300.041 695.021 299.997 695.023 299.953 695.03C292.975 696.019 287.637 702.067 287.936 709.426C288.14 716.877 294.502 723 301.943 723C302.002 723 302.053 723 302.112 723C305.071 722.963 307.795 722.011 310.034 720.421C310.502 720.092 310.531 719.411 310.128 719.009L301 709.875ZM302.09 721.125C295.305 721.125 289.973 715.549 289.756 709.359C289.561 703.494 293.523 698.405 299.125 697.095V709.874C299.125 710.371 299.323 710.848 299.674 711.2L307.989 719.514C306.191 720.545 304.176 721.096 302.09 721.125ZM317.822 706.078C317.336 699.076 311.74 693.533 304.744 693C304.122 693 303.762 693.479 303.762 693.952L303.762 706.121C303.762 706.639 304.182 707.059 304.7 707.059L316.87 707.059C317.459 707.062 317.91 706.617 317.822 706.078ZM305.635 705.188V694.985C310.914 695.798 315.074 699.961 315.889 705.188H305.635Z",
    fill: "#1DE9B6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 275.5,
    y: 680.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 83H690",
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 708H687",
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736 81C736 81 920 81 936 81C952 81 959.5 86 959.5 104C959.5 110.032 959.5 150.179 959.5 163C959.5 175.821 966 185 981.5 185H1198",
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.5 710C274.5 710 180 710 157.5 710C135 710 123 699 123 680.5C123 662 123 502.5 123 502.5",
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019 399C1019 399 1106.5 399 1133 399C1159.5 399 1170.5 405.5 1170.5 431C1170.5 456.5 1170.5 639.5 1170.5 639.5",
    stroke: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 790.8C1351.9 790.8 1352.2 791.1 1352.2 791.4C1352.2 791.7 1351.9 792 1351.6 792C1351.3 792 1351 791.7 1351 791.4C1351 791 1351.3 790.8 1351.6 790.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 777.9C1351.93 777.9 1352.2 777.631 1352.2 777.3C1352.2 776.969 1351.93 776.7 1351.6 776.7C1351.27 776.7 1351 776.969 1351 777.3C1351 777.631 1351.27 777.9 1351.6 777.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 763.9C1351.93 763.9 1352.2 763.631 1352.2 763.3C1352.2 762.969 1351.93 762.7 1351.6 762.7C1351.27 762.7 1351 762.969 1351 763.3C1351 763.631 1351.27 763.9 1351.6 763.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 749.8C1351.93 749.8 1352.2 749.531 1352.2 749.2C1352.2 748.869 1351.93 748.6 1351.6 748.6C1351.27 748.6 1351 748.869 1351 749.2C1351 749.531 1351.27 749.8 1351.6 749.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 735.7C1351.93 735.7 1352.2 735.431 1352.2 735.1C1352.2 734.769 1351.93 734.5 1351.6 734.5C1351.27 734.5 1351 734.769 1351 735.1C1351 735.431 1351.27 735.7 1351.6 735.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 721.7C1351.93 721.7 1352.2 721.431 1352.2 721.1C1352.2 720.769 1351.93 720.5 1351.6 720.5C1351.27 720.5 1351 720.769 1351 721.1C1351 721.431 1351.27 721.7 1351.6 721.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 707.6C1351.93 707.6 1352.2 707.331 1352.2 707C1352.2 706.669 1351.93 706.4 1351.6 706.4C1351.27 706.4 1351 706.669 1351 707C1351 707.331 1351.27 707.6 1351.6 707.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 692.4C1351.9 692.4 1352.2 692.7 1352.2 693C1352.2 693.3 1351.9 693.6 1351.6 693.6C1351.3 693.6 1351 693.3 1351 693C1351 692.7 1351.3 692.4 1351.6 692.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 679.5C1351.93 679.5 1352.2 679.231 1352.2 678.9C1352.2 678.569 1351.93 678.3 1351.6 678.3C1351.27 678.3 1351 678.569 1351 678.9C1351 679.231 1351.27 679.5 1351.6 679.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 664.3C1351.9 664.3 1352.2 664.6 1352.2 664.9C1352.2 665.2 1351.9 665.5 1351.6 665.5C1351.3 665.5 1351 665.2 1351 664.9C1351 664.6 1351.3 664.3 1351.6 664.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 651.4C1351.93 651.4 1352.2 651.131 1352.2 650.8C1352.2 650.469 1351.93 650.2 1351.6 650.2C1351.27 650.2 1351 650.469 1351 650.8C1351 651.131 1351.27 651.4 1351.6 651.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 637.4C1351.93 637.4 1352.2 637.131 1352.2 636.8C1352.2 636.469 1351.93 636.2 1351.6 636.2C1351.27 636.2 1351 636.469 1351 636.8C1351 637.131 1351.27 637.4 1351.6 637.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 623.3C1351.93 623.3 1352.2 623.031 1352.2 622.7C1352.2 622.369 1351.93 622.1 1351.6 622.1C1351.27 622.1 1351 622.369 1351 622.7C1351 623.031 1351.27 623.3 1351.6 623.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 609.3C1351.93 609.3 1352.2 609.031 1352.2 608.7C1352.2 608.369 1351.93 608.1 1351.6 608.1C1351.27 608.1 1351 608.369 1351 608.7C1351 609.031 1351.27 609.3 1351.6 609.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351.6 595.2C1351.93 595.2 1352.2 594.931 1352.2 594.6C1352.2 594.269 1351.93 594 1351.6 594C1351.27 594 1351 594.269 1351 594.6C1351 594.931 1351.27 595.2 1351.6 595.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 790.8C1339.9 790.8 1340.2 791.1 1340.2 791.4C1340.2 791.7 1339.9 792 1339.6 792C1339.3 792 1339 791.7 1339 791.4C1339 791 1339.3 790.8 1339.6 790.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 777.9C1339.93 777.9 1340.2 777.631 1340.2 777.3C1340.2 776.969 1339.93 776.7 1339.6 776.7C1339.27 776.7 1339 776.969 1339 777.3C1339 777.631 1339.27 777.9 1339.6 777.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 763.9C1339.93 763.9 1340.2 763.631 1340.2 763.3C1340.2 762.969 1339.93 762.7 1339.6 762.7C1339.27 762.7 1339 762.969 1339 763.3C1339 763.631 1339.27 763.9 1339.6 763.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 749.8C1339.93 749.8 1340.2 749.531 1340.2 749.2C1340.2 748.869 1339.93 748.6 1339.6 748.6C1339.27 748.6 1339 748.869 1339 749.2C1339 749.531 1339.27 749.8 1339.6 749.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 735.7C1339.93 735.7 1340.2 735.431 1340.2 735.1C1340.2 734.769 1339.93 734.5 1339.6 734.5C1339.27 734.5 1339 734.769 1339 735.1C1339 735.431 1339.27 735.7 1339.6 735.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 721.7C1339.93 721.7 1340.2 721.431 1340.2 721.1C1340.2 720.769 1339.93 720.5 1339.6 720.5C1339.27 720.5 1339 720.769 1339 721.1C1339 721.431 1339.27 721.7 1339.6 721.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 707.6C1339.93 707.6 1340.2 707.331 1340.2 707C1340.2 706.669 1339.93 706.4 1339.6 706.4C1339.27 706.4 1339 706.669 1339 707C1339 707.331 1339.27 707.6 1339.6 707.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 692.4C1339.9 692.4 1340.2 692.7 1340.2 693C1340.2 693.3 1339.9 693.6 1339.6 693.6C1339.3 693.6 1339 693.3 1339 693C1339 692.7 1339.3 692.4 1339.6 692.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 679.5C1339.93 679.5 1340.2 679.231 1340.2 678.9C1340.2 678.569 1339.93 678.3 1339.6 678.3C1339.27 678.3 1339 678.569 1339 678.9C1339 679.231 1339.27 679.5 1339.6 679.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 664.3C1339.9 664.3 1340.2 664.6 1340.2 664.9C1340.2 665.2 1339.9 665.5 1339.6 665.5C1339.3 665.5 1339 665.2 1339 664.9C1339 664.6 1339.3 664.3 1339.6 664.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 651.4C1339.93 651.4 1340.2 651.131 1340.2 650.8C1340.2 650.469 1339.93 650.2 1339.6 650.2C1339.27 650.2 1339 650.469 1339 650.8C1339 651.131 1339.27 651.4 1339.6 651.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 637.4C1339.93 637.4 1340.2 637.131 1340.2 636.8C1340.2 636.469 1339.93 636.2 1339.6 636.2C1339.27 636.2 1339 636.469 1339 636.8C1339 637.131 1339.27 637.4 1339.6 637.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 623.3C1339.93 623.3 1340.2 623.031 1340.2 622.7C1340.2 622.369 1339.93 622.1 1339.6 622.1C1339.27 622.1 1339 622.369 1339 622.7C1339 623.031 1339.27 623.3 1339.6 623.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 609.3C1339.93 609.3 1340.2 609.031 1340.2 608.7C1340.2 608.369 1339.93 608.1 1339.6 608.1C1339.27 608.1 1339 608.369 1339 608.7C1339 609.031 1339.27 609.3 1339.6 609.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.6 595.2C1339.93 595.2 1340.2 594.931 1340.2 594.6C1340.2 594.269 1339.93 594 1339.6 594C1339.27 594 1339 594.269 1339 594.6C1339 594.931 1339.27 595.2 1339.6 595.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 790.8C1327.9 790.8 1328.2 791.1 1328.2 791.4C1328.2 791.7 1327.9 792 1327.6 792C1327.3 792 1327 791.7 1327 791.4C1327 791 1327.3 790.8 1327.6 790.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 777.9C1327.93 777.9 1328.2 777.631 1328.2 777.3C1328.2 776.969 1327.93 776.7 1327.6 776.7C1327.27 776.7 1327 776.969 1327 777.3C1327 777.631 1327.27 777.9 1327.6 777.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 763.9C1327.93 763.9 1328.2 763.631 1328.2 763.3C1328.2 762.969 1327.93 762.7 1327.6 762.7C1327.27 762.7 1327 762.969 1327 763.3C1327 763.631 1327.27 763.9 1327.6 763.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 749.8C1327.93 749.8 1328.2 749.531 1328.2 749.2C1328.2 748.869 1327.93 748.6 1327.6 748.6C1327.27 748.6 1327 748.869 1327 749.2C1327 749.531 1327.27 749.8 1327.6 749.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 735.7C1327.93 735.7 1328.2 735.431 1328.2 735.1C1328.2 734.769 1327.93 734.5 1327.6 734.5C1327.27 734.5 1327 734.769 1327 735.1C1327 735.431 1327.27 735.7 1327.6 735.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 721.7C1327.93 721.7 1328.2 721.431 1328.2 721.1C1328.2 720.769 1327.93 720.5 1327.6 720.5C1327.27 720.5 1327 720.769 1327 721.1C1327 721.431 1327.27 721.7 1327.6 721.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 707.6C1327.93 707.6 1328.2 707.331 1328.2 707C1328.2 706.669 1327.93 706.4 1327.6 706.4C1327.27 706.4 1327 706.669 1327 707C1327 707.331 1327.27 707.6 1327.6 707.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 692.4C1327.9 692.4 1328.2 692.7 1328.2 693C1328.2 693.3 1327.9 693.6 1327.6 693.6C1327.3 693.6 1327 693.3 1327 693C1327 692.7 1327.3 692.4 1327.6 692.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 679.5C1327.93 679.5 1328.2 679.231 1328.2 678.9C1328.2 678.569 1327.93 678.3 1327.6 678.3C1327.27 678.3 1327 678.569 1327 678.9C1327 679.231 1327.27 679.5 1327.6 679.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 664.3C1327.9 664.3 1328.2 664.6 1328.2 664.9C1328.2 665.2 1327.9 665.5 1327.6 665.5C1327.3 665.5 1327 665.2 1327 664.9C1327 664.6 1327.3 664.3 1327.6 664.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 651.4C1327.93 651.4 1328.2 651.131 1328.2 650.8C1328.2 650.469 1327.93 650.2 1327.6 650.2C1327.27 650.2 1327 650.469 1327 650.8C1327 651.131 1327.27 651.4 1327.6 651.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 637.4C1327.93 637.4 1328.2 637.131 1328.2 636.8C1328.2 636.469 1327.93 636.2 1327.6 636.2C1327.27 636.2 1327 636.469 1327 636.8C1327 637.131 1327.27 637.4 1327.6 637.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 623.3C1327.93 623.3 1328.2 623.031 1328.2 622.7C1328.2 622.369 1327.93 622.1 1327.6 622.1C1327.27 622.1 1327 622.369 1327 622.7C1327 623.031 1327.27 623.3 1327.6 623.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 609.3C1327.93 609.3 1328.2 609.031 1328.2 608.7C1328.2 608.369 1327.93 608.1 1327.6 608.1C1327.27 608.1 1327 608.369 1327 608.7C1327 609.031 1327.27 609.3 1327.6 609.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.6 595.2C1327.93 595.2 1328.2 594.931 1328.2 594.6C1328.2 594.269 1327.93 594 1327.6 594C1327.27 594 1327 594.269 1327 594.6C1327 594.931 1327.27 595.2 1327.6 595.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 790.8C1363.9 790.8 1364.2 791.1 1364.2 791.4C1364.2 791.7 1363.9 792 1363.6 792C1363.3 792 1363 791.7 1363 791.4C1363 791 1363.3 790.8 1363.6 790.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 777.9C1363.93 777.9 1364.2 777.631 1364.2 777.3C1364.2 776.969 1363.93 776.7 1363.6 776.7C1363.27 776.7 1363 776.969 1363 777.3C1363 777.631 1363.27 777.9 1363.6 777.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 763.9C1363.93 763.9 1364.2 763.631 1364.2 763.3C1364.2 762.969 1363.93 762.7 1363.6 762.7C1363.27 762.7 1363 762.969 1363 763.3C1363 763.631 1363.27 763.9 1363.6 763.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 749.8C1363.93 749.8 1364.2 749.531 1364.2 749.2C1364.2 748.869 1363.93 748.6 1363.6 748.6C1363.27 748.6 1363 748.869 1363 749.2C1363 749.531 1363.27 749.8 1363.6 749.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 735.7C1363.93 735.7 1364.2 735.431 1364.2 735.1C1364.2 734.769 1363.93 734.5 1363.6 734.5C1363.27 734.5 1363 734.769 1363 735.1C1363 735.431 1363.27 735.7 1363.6 735.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 721.7C1363.93 721.7 1364.2 721.431 1364.2 721.1C1364.2 720.769 1363.93 720.5 1363.6 720.5C1363.27 720.5 1363 720.769 1363 721.1C1363 721.431 1363.27 721.7 1363.6 721.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 707.6C1363.93 707.6 1364.2 707.331 1364.2 707C1364.2 706.669 1363.93 706.4 1363.6 706.4C1363.27 706.4 1363 706.669 1363 707C1363 707.331 1363.27 707.6 1363.6 707.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 692.4C1363.9 692.4 1364.2 692.7 1364.2 693C1364.2 693.3 1363.9 693.6 1363.6 693.6C1363.3 693.6 1363 693.3 1363 693C1363 692.7 1363.3 692.4 1363.6 692.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 679.5C1363.93 679.5 1364.2 679.231 1364.2 678.9C1364.2 678.569 1363.93 678.3 1363.6 678.3C1363.27 678.3 1363 678.569 1363 678.9C1363 679.231 1363.27 679.5 1363.6 679.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 664.3C1363.9 664.3 1364.2 664.6 1364.2 664.9C1364.2 665.2 1363.9 665.5 1363.6 665.5C1363.3 665.5 1363 665.2 1363 664.9C1363 664.6 1363.3 664.3 1363.6 664.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 651.4C1363.93 651.4 1364.2 651.131 1364.2 650.8C1364.2 650.469 1363.93 650.2 1363.6 650.2C1363.27 650.2 1363 650.469 1363 650.8C1363 651.131 1363.27 651.4 1363.6 651.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 637.4C1363.93 637.4 1364.2 637.131 1364.2 636.8C1364.2 636.469 1363.93 636.2 1363.6 636.2C1363.27 636.2 1363 636.469 1363 636.8C1363 637.131 1363.27 637.4 1363.6 637.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 623.3C1363.93 623.3 1364.2 623.031 1364.2 622.7C1364.2 622.369 1363.93 622.1 1363.6 622.1C1363.27 622.1 1363 622.369 1363 622.7C1363 623.031 1363.27 623.3 1363.6 623.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 609.3C1363.93 609.3 1364.2 609.031 1364.2 608.7C1364.2 608.369 1363.93 608.1 1363.6 608.1C1363.27 608.1 1363 608.369 1363 608.7C1363 609.031 1363.27 609.3 1363.6 609.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.6 595.2C1363.93 595.2 1364.2 594.931 1364.2 594.6C1364.2 594.269 1363.93 594 1363.6 594C1363.27 594 1363 594.269 1363 594.6C1363 594.931 1363.27 595.2 1363.6 595.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 790.8C1375.9 790.8 1376.2 791.1 1376.2 791.4C1376.2 791.7 1375.9 792 1375.6 792C1375.3 792 1375 791.7 1375 791.4C1375 791 1375.3 790.8 1375.6 790.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 777.9C1375.93 777.9 1376.2 777.631 1376.2 777.3C1376.2 776.969 1375.93 776.7 1375.6 776.7C1375.27 776.7 1375 776.969 1375 777.3C1375 777.631 1375.27 777.9 1375.6 777.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 763.9C1375.93 763.9 1376.2 763.631 1376.2 763.3C1376.2 762.969 1375.93 762.7 1375.6 762.7C1375.27 762.7 1375 762.969 1375 763.3C1375 763.631 1375.27 763.9 1375.6 763.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 749.8C1375.93 749.8 1376.2 749.531 1376.2 749.2C1376.2 748.869 1375.93 748.6 1375.6 748.6C1375.27 748.6 1375 748.869 1375 749.2C1375 749.531 1375.27 749.8 1375.6 749.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 735.7C1375.93 735.7 1376.2 735.431 1376.2 735.1C1376.2 734.769 1375.93 734.5 1375.6 734.5C1375.27 734.5 1375 734.769 1375 735.1C1375 735.431 1375.27 735.7 1375.6 735.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 721.7C1375.93 721.7 1376.2 721.431 1376.2 721.1C1376.2 720.769 1375.93 720.5 1375.6 720.5C1375.27 720.5 1375 720.769 1375 721.1C1375 721.431 1375.27 721.7 1375.6 721.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 707.6C1375.93 707.6 1376.2 707.331 1376.2 707C1376.2 706.669 1375.93 706.4 1375.6 706.4C1375.27 706.4 1375 706.669 1375 707C1375 707.331 1375.27 707.6 1375.6 707.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 692.4C1375.9 692.4 1376.2 692.7 1376.2 693C1376.2 693.3 1375.9 693.6 1375.6 693.6C1375.3 693.6 1375 693.3 1375 693C1375 692.7 1375.3 692.4 1375.6 692.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 679.5C1375.93 679.5 1376.2 679.231 1376.2 678.9C1376.2 678.569 1375.93 678.3 1375.6 678.3C1375.27 678.3 1375 678.569 1375 678.9C1375 679.231 1375.27 679.5 1375.6 679.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 664.3C1375.9 664.3 1376.2 664.6 1376.2 664.9C1376.2 665.2 1375.9 665.5 1375.6 665.5C1375.3 665.5 1375 665.2 1375 664.9C1375 664.6 1375.3 664.3 1375.6 664.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 651.4C1375.93 651.4 1376.2 651.131 1376.2 650.8C1376.2 650.469 1375.93 650.2 1375.6 650.2C1375.27 650.2 1375 650.469 1375 650.8C1375 651.131 1375.27 651.4 1375.6 651.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 637.4C1375.93 637.4 1376.2 637.131 1376.2 636.8C1376.2 636.469 1375.93 636.2 1375.6 636.2C1375.27 636.2 1375 636.469 1375 636.8C1375 637.131 1375.27 637.4 1375.6 637.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 623.3C1375.93 623.3 1376.2 623.031 1376.2 622.7C1376.2 622.369 1375.93 622.1 1375.6 622.1C1375.27 622.1 1375 622.369 1375 622.7C1375 623.031 1375.27 623.3 1375.6 623.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 609.3C1375.93 609.3 1376.2 609.031 1376.2 608.7C1376.2 608.369 1375.93 608.1 1375.6 608.1C1375.27 608.1 1375 608.369 1375 608.7C1375 609.031 1375.27 609.3 1375.6 609.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6 595.2C1375.93 595.2 1376.2 594.931 1376.2 594.6C1376.2 594.269 1375.93 594 1375.6 594C1375.27 594 1375 594.269 1375 594.6C1375 594.931 1375.27 595.2 1375.6 595.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 790.8C1387.9 790.8 1388.2 791.1 1388.2 791.4C1388.2 791.7 1387.9 792 1387.6 792C1387.3 792 1387 791.7 1387 791.4C1387 791 1387.3 790.8 1387.6 790.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 777.9C1387.93 777.9 1388.2 777.631 1388.2 777.3C1388.2 776.969 1387.93 776.7 1387.6 776.7C1387.27 776.7 1387 776.969 1387 777.3C1387 777.631 1387.27 777.9 1387.6 777.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 763.9C1387.93 763.9 1388.2 763.631 1388.2 763.3C1388.2 762.969 1387.93 762.7 1387.6 762.7C1387.27 762.7 1387 762.969 1387 763.3C1387 763.631 1387.27 763.9 1387.6 763.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 749.8C1387.93 749.8 1388.2 749.531 1388.2 749.2C1388.2 748.869 1387.93 748.6 1387.6 748.6C1387.27 748.6 1387 748.869 1387 749.2C1387 749.531 1387.27 749.8 1387.6 749.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 735.7C1387.93 735.7 1388.2 735.431 1388.2 735.1C1388.2 734.769 1387.93 734.5 1387.6 734.5C1387.27 734.5 1387 734.769 1387 735.1C1387 735.431 1387.27 735.7 1387.6 735.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 721.7C1387.93 721.7 1388.2 721.431 1388.2 721.1C1388.2 720.769 1387.93 720.5 1387.6 720.5C1387.27 720.5 1387 720.769 1387 721.1C1387 721.431 1387.27 721.7 1387.6 721.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 707.6C1387.93 707.6 1388.2 707.331 1388.2 707C1388.2 706.669 1387.93 706.4 1387.6 706.4C1387.27 706.4 1387 706.669 1387 707C1387 707.331 1387.27 707.6 1387.6 707.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 692.4C1387.9 692.4 1388.2 692.7 1388.2 693C1388.2 693.3 1387.9 693.6 1387.6 693.6C1387.3 693.6 1387 693.3 1387 693C1387 692.7 1387.3 692.4 1387.6 692.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 679.5C1387.93 679.5 1388.2 679.231 1388.2 678.9C1388.2 678.569 1387.93 678.3 1387.6 678.3C1387.27 678.3 1387 678.569 1387 678.9C1387 679.231 1387.27 679.5 1387.6 679.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 664.3C1387.9 664.3 1388.2 664.6 1388.2 664.9C1388.2 665.2 1387.9 665.5 1387.6 665.5C1387.3 665.5 1387 665.2 1387 664.9C1387 664.6 1387.3 664.3 1387.6 664.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 651.4C1387.93 651.4 1388.2 651.131 1388.2 650.8C1388.2 650.469 1387.93 650.2 1387.6 650.2C1387.27 650.2 1387 650.469 1387 650.8C1387 651.131 1387.27 651.4 1387.6 651.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 637.4C1387.93 637.4 1388.2 637.131 1388.2 636.8C1388.2 636.469 1387.93 636.2 1387.6 636.2C1387.27 636.2 1387 636.469 1387 636.8C1387 637.131 1387.27 637.4 1387.6 637.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 623.3C1387.93 623.3 1388.2 623.031 1388.2 622.7C1388.2 622.369 1387.93 622.1 1387.6 622.1C1387.27 622.1 1387 622.369 1387 622.7C1387 623.031 1387.27 623.3 1387.6 623.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 609.3C1387.93 609.3 1388.2 609.031 1388.2 608.7C1388.2 608.369 1387.93 608.1 1387.6 608.1C1387.27 608.1 1387 608.369 1387 608.7C1387 609.031 1387.27 609.3 1387.6 609.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.6 595.2C1387.93 595.2 1388.2 594.931 1388.2 594.6C1388.2 594.269 1387.93 594 1387.6 594C1387.27 594 1387 594.269 1387 594.6C1387 594.931 1387.27 595.2 1387.6 595.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 790.8C1399.9 790.8 1400.2 791.1 1400.2 791.4C1400.2 791.7 1399.9 792 1399.6 792C1399.3 792 1399 791.7 1399 791.4C1399 791 1399.3 790.8 1399.6 790.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 776.7C1399.9 776.7 1400.2 777 1400.2 777.3C1400.2 777.6 1399.9 777.9 1399.6 777.9C1399.3 777.9 1399 777.6 1399 777.3C1399 777 1399.3 776.7 1399.6 776.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 762.6C1399.9 762.6 1400.2 762.9 1400.2 763.2C1400.2 763.5 1399.9 763.8 1399.6 763.8C1399.3 763.8 1399 763.5 1399 763.2C1399 762.9 1399.3 762.6 1399.6 762.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 748.6C1399.9 748.6 1400.2 748.9 1400.2 749.2C1400.2 749.5 1399.9 749.8 1399.6 749.8C1399.3 749.8 1399 749.5 1399 749.2C1399 748.9 1399.3 748.6 1399.6 748.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 734.5C1399.9 734.5 1400.2 734.8 1400.2 735.1C1400.2 735.4 1399.9 735.7 1399.6 735.7C1399.3 735.7 1399 735.4 1399 735.1C1399 734.8 1399.3 734.5 1399.6 734.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 720.5C1399.9 720.5 1400.2 720.8 1400.2 721.1C1400.2 721.4 1399.9 721.7 1399.6 721.7C1399.3 721.7 1399 721.4 1399 721.1C1399 720.8 1399.3 720.5 1399.6 720.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 706.4C1399.9 706.4 1400.2 706.7 1400.2 707C1400.2 707.3 1399.9 707.6 1399.6 707.6C1399.3 707.6 1399 707.3 1399 707C1399 706.7 1399.3 706.4 1399.6 706.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 692.4C1399.9 692.4 1400.2 692.7 1400.2 693C1400.2 693.3 1399.9 693.6 1399.6 693.6C1399.3 693.6 1399 693.3 1399 693C1399 692.7 1399.3 692.4 1399.6 692.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 678.3C1399.9 678.3 1400.2 678.6 1400.2 678.9C1400.2 679.2 1399.9 679.5 1399.6 679.5C1399.3 679.5 1399 679.2 1399 678.9C1399 678.6 1399.3 678.3 1399.6 678.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 664.3C1399.9 664.3 1400.2 664.6 1400.2 664.9C1400.2 665.2 1399.9 665.5 1399.6 665.5C1399.3 665.5 1399 665.2 1399 664.9C1399 664.6 1399.3 664.3 1399.6 664.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 650.2C1399.9 650.2 1400.2 650.5 1400.2 650.8C1400.2 651.1 1399.9 651.4 1399.6 651.4C1399.3 651.4 1399 651.1 1399 650.8C1399 650.5 1399.3 650.2 1399.6 650.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 636.2C1399.9 636.2 1400.2 636.5 1400.2 636.8C1400.2 637.1 1399.9 637.4 1399.6 637.4C1399.3 637.4 1399 637.1 1399 636.8C1399 636.4 1399.3 636.2 1399.6 636.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 622.1C1399.9 622.1 1400.2 622.4 1400.2 622.7C1400.2 623 1399.9 623.3 1399.6 623.3C1399.3 623.3 1399 623 1399 622.7C1399 622.4 1399.3 622.1 1399.6 622.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 608.1C1399.9 608.1 1400.2 608.4 1400.2 608.7C1400.2 609 1399.9 609.3 1399.6 609.3C1399.3 609.3 1399 609 1399 608.7C1399 608.3 1399.3 608.1 1399.6 608.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.6 594C1399.9 594 1400.2 594.3 1400.2 594.6C1400.2 594.9 1399.9 595.2 1399.6 595.2C1399.3 595.2 1399 594.9 1399 594.6C1399 594.3 1399.3 594 1399.6 594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 790.8C1411.9 790.8 1412.2 791.1 1412.2 791.4C1412.2 791.7 1411.9 792 1411.6 792C1411.3 792 1411 791.7 1411 791.4C1411 791 1411.3 790.8 1411.6 790.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 776.7C1411.9 776.7 1412.2 777 1412.2 777.3C1412.2 777.6 1411.9 777.9 1411.6 777.9C1411.3 777.9 1411 777.6 1411 777.3C1411 777 1411.3 776.7 1411.6 776.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 762.6C1411.9 762.6 1412.2 762.9 1412.2 763.2C1412.2 763.5 1411.9 763.8 1411.6 763.8C1411.3 763.8 1411 763.5 1411 763.2C1411 762.9 1411.3 762.6 1411.6 762.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 748.6C1411.9 748.6 1412.2 748.9 1412.2 749.2C1412.2 749.5 1411.9 749.8 1411.6 749.8C1411.3 749.8 1411 749.5 1411 749.2C1411 748.9 1411.3 748.6 1411.6 748.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 734.5C1411.9 734.5 1412.2 734.8 1412.2 735.1C1412.2 735.4 1411.9 735.7 1411.6 735.7C1411.3 735.7 1411 735.4 1411 735.1C1411 734.8 1411.3 734.5 1411.6 734.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 720.5C1411.9 720.5 1412.2 720.8 1412.2 721.1C1412.2 721.4 1411.9 721.7 1411.6 721.7C1411.3 721.7 1411 721.4 1411 721.1C1411 720.8 1411.3 720.5 1411.6 720.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 706.4C1411.9 706.4 1412.2 706.7 1412.2 707C1412.2 707.3 1411.9 707.6 1411.6 707.6C1411.3 707.6 1411 707.3 1411 707C1411 706.7 1411.3 706.4 1411.6 706.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 692.4C1411.9 692.4 1412.2 692.7 1412.2 693C1412.2 693.3 1411.9 693.6 1411.6 693.6C1411.3 693.6 1411 693.3 1411 693C1411 692.7 1411.3 692.4 1411.6 692.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 678.3C1411.9 678.3 1412.2 678.6 1412.2 678.9C1412.2 679.2 1411.9 679.5 1411.6 679.5C1411.3 679.5 1411 679.2 1411 678.9C1411 678.6 1411.3 678.3 1411.6 678.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 664.3C1411.9 664.3 1412.2 664.6 1412.2 664.9C1412.2 665.2 1411.9 665.5 1411.6 665.5C1411.3 665.5 1411 665.2 1411 664.9C1411 664.6 1411.3 664.3 1411.6 664.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 650.2C1411.9 650.2 1412.2 650.5 1412.2 650.8C1412.2 651.1 1411.9 651.4 1411.6 651.4C1411.3 651.4 1411 651.1 1411 650.8C1411 650.5 1411.3 650.2 1411.6 650.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 636.2C1411.9 636.2 1412.2 636.5 1412.2 636.8C1412.2 637.1 1411.9 637.4 1411.6 637.4C1411.3 637.4 1411 637.1 1411 636.8C1411 636.4 1411.3 636.2 1411.6 636.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 622.1C1411.9 622.1 1412.2 622.4 1412.2 622.7C1412.2 623 1411.9 623.3 1411.6 623.3C1411.3 623.3 1411 623 1411 622.7C1411 622.4 1411.3 622.1 1411.6 622.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 608.1C1411.9 608.1 1412.2 608.4 1412.2 608.7C1412.2 609 1411.9 609.3 1411.6 609.3C1411.3 609.3 1411 609 1411 608.7C1411 608.3 1411.3 608.1 1411.6 608.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.6 594C1411.9 594 1412.2 594.3 1412.2 594.6C1412.2 594.9 1411.9 595.2 1411.6 595.2C1411.3 595.2 1411 594.9 1411 594.6C1411 594.3 1411.3 594 1411.6 594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 790.8C1423.9 790.8 1424.2 791.1 1424.2 791.4C1424.2 791.7 1423.9 792 1423.6 792C1423.3 792 1423 791.7 1423 791.4C1423 791 1423.3 790.8 1423.6 790.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 776.7C1423.9 776.7 1424.2 777 1424.2 777.3C1424.2 777.6 1423.9 777.9 1423.6 777.9C1423.3 777.9 1423 777.6 1423 777.3C1423 777 1423.3 776.7 1423.6 776.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 762.6C1423.9 762.6 1424.2 762.9 1424.2 763.2C1424.2 763.5 1423.9 763.8 1423.6 763.8C1423.3 763.8 1423 763.5 1423 763.2C1423 762.9 1423.3 762.6 1423.6 762.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 748.6C1423.9 748.6 1424.2 748.9 1424.2 749.2C1424.2 749.5 1423.9 749.8 1423.6 749.8C1423.3 749.8 1423 749.5 1423 749.2C1423 748.9 1423.3 748.6 1423.6 748.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 734.5C1423.9 734.5 1424.2 734.8 1424.2 735.1C1424.2 735.4 1423.9 735.7 1423.6 735.7C1423.3 735.7 1423 735.4 1423 735.1C1423 734.8 1423.3 734.5 1423.6 734.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 720.5C1423.9 720.5 1424.2 720.8 1424.2 721.1C1424.2 721.4 1423.9 721.7 1423.6 721.7C1423.3 721.7 1423 721.4 1423 721.1C1423 720.8 1423.3 720.5 1423.6 720.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 706.4C1423.9 706.4 1424.2 706.7 1424.2 707C1424.2 707.3 1423.9 707.6 1423.6 707.6C1423.3 707.6 1423 707.3 1423 707C1423 706.7 1423.3 706.4 1423.6 706.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 692.4C1423.9 692.4 1424.2 692.7 1424.2 693C1424.2 693.3 1423.9 693.6 1423.6 693.6C1423.3 693.6 1423 693.3 1423 693C1423 692.7 1423.3 692.4 1423.6 692.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 678.3C1423.9 678.3 1424.2 678.6 1424.2 678.9C1424.2 679.2 1423.9 679.5 1423.6 679.5C1423.3 679.5 1423 679.2 1423 678.9C1423 678.6 1423.3 678.3 1423.6 678.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 664.3C1423.9 664.3 1424.2 664.6 1424.2 664.9C1424.2 665.2 1423.9 665.5 1423.6 665.5C1423.3 665.5 1423 665.2 1423 664.9C1423 664.6 1423.3 664.3 1423.6 664.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 650.2C1423.9 650.2 1424.2 650.5 1424.2 650.8C1424.2 651.1 1423.9 651.4 1423.6 651.4C1423.3 651.4 1423 651.1 1423 650.8C1423 650.5 1423.3 650.2 1423.6 650.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 636.2C1423.9 636.2 1424.2 636.5 1424.2 636.8C1424.2 637.1 1423.9 637.4 1423.6 637.4C1423.3 637.4 1423 637.1 1423 636.8C1423 636.4 1423.3 636.2 1423.6 636.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 622.1C1423.9 622.1 1424.2 622.4 1424.2 622.7C1424.2 623 1423.9 623.3 1423.6 623.3C1423.3 623.3 1423 623 1423 622.7C1423 622.4 1423.3 622.1 1423.6 622.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 608.1C1423.9 608.1 1424.2 608.4 1424.2 608.7C1424.2 609 1423.9 609.3 1423.6 609.3C1423.3 609.3 1423 609 1423 608.7C1423 608.3 1423.3 608.1 1423.6 608.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.6 594C1423.9 594 1424.2 594.3 1424.2 594.6C1424.2 594.9 1423.9 595.2 1423.6 595.2C1423.3 595.2 1423 594.9 1423 594.6C1423 594.3 1423.3 594 1423.6 594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 790.8C1435.9 790.8 1436.2 791.1 1436.2 791.4C1436.2 791.7 1435.9 792 1435.6 792C1435.3 792 1435 791.7 1435 791.4C1435 791 1435.3 790.8 1435.6 790.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 777.9C1435.93 777.9 1436.2 777.631 1436.2 777.3C1436.2 776.969 1435.93 776.7 1435.6 776.7C1435.27 776.7 1435 776.969 1435 777.3C1435 777.631 1435.27 777.9 1435.6 777.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 763.9C1435.93 763.9 1436.2 763.631 1436.2 763.3C1436.2 762.969 1435.93 762.7 1435.6 762.7C1435.27 762.7 1435 762.969 1435 763.3C1435 763.631 1435.27 763.9 1435.6 763.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 749.8C1435.93 749.8 1436.2 749.531 1436.2 749.2C1436.2 748.869 1435.93 748.6 1435.6 748.6C1435.27 748.6 1435 748.869 1435 749.2C1435 749.531 1435.27 749.8 1435.6 749.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 735.7C1435.93 735.7 1436.2 735.431 1436.2 735.1C1436.2 734.769 1435.93 734.5 1435.6 734.5C1435.27 734.5 1435 734.769 1435 735.1C1435 735.431 1435.27 735.7 1435.6 735.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 721.7C1435.93 721.7 1436.2 721.431 1436.2 721.1C1436.2 720.769 1435.93 720.5 1435.6 720.5C1435.27 720.5 1435 720.769 1435 721.1C1435 721.431 1435.27 721.7 1435.6 721.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 707.6C1435.93 707.6 1436.2 707.331 1436.2 707C1436.2 706.669 1435.93 706.4 1435.6 706.4C1435.27 706.4 1435 706.669 1435 707C1435 707.331 1435.27 707.6 1435.6 707.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 692.4C1435.9 692.4 1436.2 692.7 1436.2 693C1436.2 693.3 1435.9 693.6 1435.6 693.6C1435.3 693.6 1435 693.3 1435 693C1435 692.7 1435.3 692.4 1435.6 692.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 679.5C1435.93 679.5 1436.2 679.231 1436.2 678.9C1436.2 678.569 1435.93 678.3 1435.6 678.3C1435.27 678.3 1435 678.569 1435 678.9C1435 679.231 1435.27 679.5 1435.6 679.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 664.3C1435.9 664.3 1436.2 664.6 1436.2 664.9C1436.2 665.2 1435.9 665.5 1435.6 665.5C1435.3 665.5 1435 665.2 1435 664.9C1435 664.6 1435.3 664.3 1435.6 664.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 651.4C1435.93 651.4 1436.2 651.131 1436.2 650.8C1436.2 650.469 1435.93 650.2 1435.6 650.2C1435.27 650.2 1435 650.469 1435 650.8C1435 651.131 1435.27 651.4 1435.6 651.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 637.4C1435.93 637.4 1436.2 637.131 1436.2 636.8C1436.2 636.469 1435.93 636.2 1435.6 636.2C1435.27 636.2 1435 636.469 1435 636.8C1435 637.131 1435.27 637.4 1435.6 637.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 623.3C1435.93 623.3 1436.2 623.031 1436.2 622.7C1436.2 622.369 1435.93 622.1 1435.6 622.1C1435.27 622.1 1435 622.369 1435 622.7C1435 623.031 1435.27 623.3 1435.6 623.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 609.3C1435.93 609.3 1436.2 609.031 1436.2 608.7C1436.2 608.369 1435.93 608.1 1435.6 608.1C1435.27 608.1 1435 608.369 1435 608.7C1435 609.031 1435.27 609.3 1435.6 609.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.6 595.2C1435.93 595.2 1436.2 594.931 1436.2 594.6C1436.2 594.269 1435.93 594 1435.6 594C1435.27 594 1435 594.269 1435 594.6C1435 594.931 1435.27 595.2 1435.6 595.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.8 94.4C1426.8 94.1 1427.1 93.8 1427.4 93.8C1427.7 93.8 1428 94.1 1428 94.4C1428 94.7 1427.7 95 1427.4 95C1427 95 1426.8 94.7 1426.8 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.9 94.4C1413.9 94.0686 1413.63 93.8 1413.3 93.8C1412.97 93.8 1412.7 94.0686 1412.7 94.4C1412.7 94.7314 1412.97 95 1413.3 95C1413.63 95 1413.9 94.7314 1413.9 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.9 94.4C1399.9 94.0686 1399.63 93.8 1399.3 93.8C1398.97 93.8 1398.7 94.0686 1398.7 94.4C1398.7 94.7314 1398.97 95 1399.3 95C1399.63 95 1399.9 94.7314 1399.9 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.8 94.4C1385.8 94.0686 1385.53 93.8 1385.2 93.8C1384.87 93.8 1384.6 94.0686 1384.6 94.4C1384.6 94.7314 1384.87 95 1385.2 95C1385.53 95 1385.8 94.7314 1385.8 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.7 94.4C1371.7 94.0686 1371.43 93.8 1371.1 93.8C1370.77 93.8 1370.5 94.0686 1370.5 94.4C1370.5 94.7314 1370.77 95 1371.1 95C1371.43 95 1371.7 94.7314 1371.7 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.7 94.4C1357.7 94.0686 1357.43 93.8 1357.1 93.8C1356.77 93.8 1356.5 94.0686 1356.5 94.4C1356.5 94.7314 1356.77 95 1357.1 95C1357.43 95 1357.7 94.7314 1357.7 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.6 94.4C1343.6 94.0686 1343.33 93.8 1343 93.8C1342.67 93.8 1342.4 94.0686 1342.4 94.4C1342.4 94.7314 1342.67 95 1343 95C1343.33 95 1343.6 94.7314 1343.6 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.4 94.4C1328.4 94.1 1328.7 93.8 1329 93.8C1329.3 93.8 1329.6 94.1 1329.6 94.4C1329.6 94.7 1329.3 95 1329 95C1328.7 95 1328.4 94.7 1328.4 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.5 94.4C1315.5 94.0686 1315.23 93.8 1314.9 93.8C1314.57 93.8 1314.3 94.0686 1314.3 94.4C1314.3 94.7314 1314.57 95 1314.9 95C1315.23 95 1315.5 94.7314 1315.5 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.3 94.4C1300.3 94.1 1300.6 93.8 1300.9 93.8C1301.2 93.8 1301.5 94.1 1301.5 94.4C1301.5 94.7 1301.2 95 1300.9 95C1300.6 95 1300.3 94.7 1300.3 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.4 94.4C1287.4 94.0686 1287.13 93.8 1286.8 93.8C1286.47 93.8 1286.2 94.0686 1286.2 94.4C1286.2 94.7314 1286.47 95 1286.8 95C1287.13 95 1287.4 94.7314 1287.4 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.4 94.4C1273.4 94.0686 1273.13 93.8 1272.8 93.8C1272.47 93.8 1272.2 94.0686 1272.2 94.4C1272.2 94.7314 1272.47 95 1272.8 95C1273.13 95 1273.4 94.7314 1273.4 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.3 94.4C1259.3 94.0686 1259.03 93.8 1258.7 93.8C1258.37 93.8 1258.1 94.0686 1258.1 94.4C1258.1 94.7314 1258.37 95 1258.7 95C1259.03 95 1259.3 94.7314 1259.3 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.3 94.4C1245.3 94.0686 1245.03 93.8 1244.7 93.8C1244.37 93.8 1244.1 94.0686 1244.1 94.4C1244.1 94.7314 1244.37 95 1244.7 95C1245.03 95 1245.3 94.7314 1245.3 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.2 94.4C1231.2 94.0686 1230.93 93.8 1230.6 93.8C1230.27 93.8 1230 94.0686 1230 94.4C1230 94.7314 1230.27 95 1230.6 95C1230.93 95 1231.2 94.7314 1231.2 94.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.8 106.4C1426.8 106.1 1427.1 105.8 1427.4 105.8C1427.7 105.8 1428 106.1 1428 106.4C1428 106.7 1427.7 107 1427.4 107C1427 107 1426.8 106.7 1426.8 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.9 106.4C1413.9 106.069 1413.63 105.8 1413.3 105.8C1412.97 105.8 1412.7 106.069 1412.7 106.4C1412.7 106.731 1412.97 107 1413.3 107C1413.63 107 1413.9 106.731 1413.9 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.9 106.4C1399.9 106.069 1399.63 105.8 1399.3 105.8C1398.97 105.8 1398.7 106.069 1398.7 106.4C1398.7 106.731 1398.97 107 1399.3 107C1399.63 107 1399.9 106.731 1399.9 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.8 106.4C1385.8 106.069 1385.53 105.8 1385.2 105.8C1384.87 105.8 1384.6 106.069 1384.6 106.4C1384.6 106.731 1384.87 107 1385.2 107C1385.53 107 1385.8 106.731 1385.8 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.7 106.4C1371.7 106.069 1371.43 105.8 1371.1 105.8C1370.77 105.8 1370.5 106.069 1370.5 106.4C1370.5 106.731 1370.77 107 1371.1 107C1371.43 107 1371.7 106.731 1371.7 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.7 106.4C1357.7 106.069 1357.43 105.8 1357.1 105.8C1356.77 105.8 1356.5 106.069 1356.5 106.4C1356.5 106.731 1356.77 107 1357.1 107C1357.43 107 1357.7 106.731 1357.7 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.6 106.4C1343.6 106.069 1343.33 105.8 1343 105.8C1342.67 105.8 1342.4 106.069 1342.4 106.4C1342.4 106.731 1342.67 107 1343 107C1343.33 107 1343.6 106.731 1343.6 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.4 106.4C1328.4 106.1 1328.7 105.8 1329 105.8C1329.3 105.8 1329.6 106.1 1329.6 106.4C1329.6 106.7 1329.3 107 1329 107C1328.7 107 1328.4 106.7 1328.4 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.5 106.4C1315.5 106.069 1315.23 105.8 1314.9 105.8C1314.57 105.8 1314.3 106.069 1314.3 106.4C1314.3 106.731 1314.57 107 1314.9 107C1315.23 107 1315.5 106.731 1315.5 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.3 106.4C1300.3 106.1 1300.6 105.8 1300.9 105.8C1301.2 105.8 1301.5 106.1 1301.5 106.4C1301.5 106.7 1301.2 107 1300.9 107C1300.6 107 1300.3 106.7 1300.3 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.4 106.4C1287.4 106.069 1287.13 105.8 1286.8 105.8C1286.47 105.8 1286.2 106.069 1286.2 106.4C1286.2 106.731 1286.47 107 1286.8 107C1287.13 107 1287.4 106.731 1287.4 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.4 106.4C1273.4 106.069 1273.13 105.8 1272.8 105.8C1272.47 105.8 1272.2 106.069 1272.2 106.4C1272.2 106.731 1272.47 107 1272.8 107C1273.13 107 1273.4 106.731 1273.4 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.3 106.4C1259.3 106.069 1259.03 105.8 1258.7 105.8C1258.37 105.8 1258.1 106.069 1258.1 106.4C1258.1 106.731 1258.37 107 1258.7 107C1259.03 107 1259.3 106.731 1259.3 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.3 106.4C1245.3 106.069 1245.03 105.8 1244.7 105.8C1244.37 105.8 1244.1 106.069 1244.1 106.4C1244.1 106.731 1244.37 107 1244.7 107C1245.03 107 1245.3 106.731 1245.3 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.2 106.4C1231.2 106.069 1230.93 105.8 1230.6 105.8C1230.27 105.8 1230 106.069 1230 106.4C1230 106.731 1230.27 107 1230.6 107C1230.93 107 1231.2 106.731 1231.2 106.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.8 118.4C1426.8 118.1 1427.1 117.8 1427.4 117.8C1427.7 117.8 1428 118.1 1428 118.4C1428 118.7 1427.7 119 1427.4 119C1427 119 1426.8 118.7 1426.8 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.9 118.4C1413.9 118.069 1413.63 117.8 1413.3 117.8C1412.97 117.8 1412.7 118.069 1412.7 118.4C1412.7 118.731 1412.97 119 1413.3 119C1413.63 119 1413.9 118.731 1413.9 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.9 118.4C1399.9 118.069 1399.63 117.8 1399.3 117.8C1398.97 117.8 1398.7 118.069 1398.7 118.4C1398.7 118.731 1398.97 119 1399.3 119C1399.63 119 1399.9 118.731 1399.9 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.8 118.4C1385.8 118.069 1385.53 117.8 1385.2 117.8C1384.87 117.8 1384.6 118.069 1384.6 118.4C1384.6 118.731 1384.87 119 1385.2 119C1385.53 119 1385.8 118.731 1385.8 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.7 118.4C1371.7 118.069 1371.43 117.8 1371.1 117.8C1370.77 117.8 1370.5 118.069 1370.5 118.4C1370.5 118.731 1370.77 119 1371.1 119C1371.43 119 1371.7 118.731 1371.7 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.7 118.4C1357.7 118.069 1357.43 117.8 1357.1 117.8C1356.77 117.8 1356.5 118.069 1356.5 118.4C1356.5 118.731 1356.77 119 1357.1 119C1357.43 119 1357.7 118.731 1357.7 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.6 118.4C1343.6 118.069 1343.33 117.8 1343 117.8C1342.67 117.8 1342.4 118.069 1342.4 118.4C1342.4 118.731 1342.67 119 1343 119C1343.33 119 1343.6 118.731 1343.6 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.4 118.4C1328.4 118.1 1328.7 117.8 1329 117.8C1329.3 117.8 1329.6 118.1 1329.6 118.4C1329.6 118.7 1329.3 119 1329 119C1328.7 119 1328.4 118.7 1328.4 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.5 118.4C1315.5 118.069 1315.23 117.8 1314.9 117.8C1314.57 117.8 1314.3 118.069 1314.3 118.4C1314.3 118.731 1314.57 119 1314.9 119C1315.23 119 1315.5 118.731 1315.5 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.3 118.4C1300.3 118.1 1300.6 117.8 1300.9 117.8C1301.2 117.8 1301.5 118.1 1301.5 118.4C1301.5 118.7 1301.2 119 1300.9 119C1300.6 119 1300.3 118.7 1300.3 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.4 118.4C1287.4 118.069 1287.13 117.8 1286.8 117.8C1286.47 117.8 1286.2 118.069 1286.2 118.4C1286.2 118.731 1286.47 119 1286.8 119C1287.13 119 1287.4 118.731 1287.4 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.4 118.4C1273.4 118.069 1273.13 117.8 1272.8 117.8C1272.47 117.8 1272.2 118.069 1272.2 118.4C1272.2 118.731 1272.47 119 1272.8 119C1273.13 119 1273.4 118.731 1273.4 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.3 118.4C1259.3 118.069 1259.03 117.8 1258.7 117.8C1258.37 117.8 1258.1 118.069 1258.1 118.4C1258.1 118.731 1258.37 119 1258.7 119C1259.03 119 1259.3 118.731 1259.3 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.3 118.4C1245.3 118.069 1245.03 117.8 1244.7 117.8C1244.37 117.8 1244.1 118.069 1244.1 118.4C1244.1 118.731 1244.37 119 1244.7 119C1245.03 119 1245.3 118.731 1245.3 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.2 118.4C1231.2 118.069 1230.93 117.8 1230.6 117.8C1230.27 117.8 1230 118.069 1230 118.4C1230 118.731 1230.27 119 1230.6 119C1230.93 119 1231.2 118.731 1231.2 118.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.8 82.4C1426.8 82.1 1427.1 81.8 1427.4 81.8C1427.7 81.8 1428 82.1 1428 82.4C1428 82.7 1427.7 83 1427.4 83C1427 83 1426.8 82.7 1426.8 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.9 82.4C1413.9 82.0686 1413.63 81.8 1413.3 81.8C1412.97 81.8 1412.7 82.0686 1412.7 82.4C1412.7 82.7314 1412.97 83 1413.3 83C1413.63 83 1413.9 82.7314 1413.9 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.9 82.4C1399.9 82.0686 1399.63 81.8 1399.3 81.8C1398.97 81.8 1398.7 82.0686 1398.7 82.4C1398.7 82.7314 1398.97 83 1399.3 83C1399.63 83 1399.9 82.7314 1399.9 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.8 82.4C1385.8 82.0686 1385.53 81.8 1385.2 81.8C1384.87 81.8 1384.6 82.0686 1384.6 82.4C1384.6 82.7314 1384.87 83 1385.2 83C1385.53 83 1385.8 82.7314 1385.8 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.7 82.4C1371.7 82.0686 1371.43 81.8 1371.1 81.8C1370.77 81.8 1370.5 82.0686 1370.5 82.4C1370.5 82.7314 1370.77 83 1371.1 83C1371.43 83 1371.7 82.7314 1371.7 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.7 82.4C1357.7 82.0686 1357.43 81.8 1357.1 81.8C1356.77 81.8 1356.5 82.0686 1356.5 82.4C1356.5 82.7314 1356.77 83 1357.1 83C1357.43 83 1357.7 82.7314 1357.7 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.6 82.4C1343.6 82.0686 1343.33 81.8 1343 81.8C1342.67 81.8 1342.4 82.0686 1342.4 82.4C1342.4 82.7314 1342.67 83 1343 83C1343.33 83 1343.6 82.7314 1343.6 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.4 82.4C1328.4 82.1 1328.7 81.8 1329 81.8C1329.3 81.8 1329.6 82.1 1329.6 82.4C1329.6 82.7 1329.3 83 1329 83C1328.7 83 1328.4 82.7 1328.4 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.5 82.4C1315.5 82.0686 1315.23 81.8 1314.9 81.8C1314.57 81.8 1314.3 82.0686 1314.3 82.4C1314.3 82.7314 1314.57 83 1314.9 83C1315.23 83 1315.5 82.7314 1315.5 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.3 82.4C1300.3 82.1 1300.6 81.8 1300.9 81.8C1301.2 81.8 1301.5 82.1 1301.5 82.4C1301.5 82.7 1301.2 83 1300.9 83C1300.6 83 1300.3 82.7 1300.3 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.4 82.4C1287.4 82.0686 1287.13 81.8 1286.8 81.8C1286.47 81.8 1286.2 82.0686 1286.2 82.4C1286.2 82.7314 1286.47 83 1286.8 83C1287.13 83 1287.4 82.7314 1287.4 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.4 82.4C1273.4 82.0686 1273.13 81.8 1272.8 81.8C1272.47 81.8 1272.2 82.0686 1272.2 82.4C1272.2 82.7314 1272.47 83 1272.8 83C1273.13 83 1273.4 82.7314 1273.4 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.3 82.4C1259.3 82.0686 1259.03 81.8 1258.7 81.8C1258.37 81.8 1258.1 82.0686 1258.1 82.4C1258.1 82.7314 1258.37 83 1258.7 83C1259.03 83 1259.3 82.7314 1259.3 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.3 82.4C1245.3 82.0686 1245.03 81.8 1244.7 81.8C1244.37 81.8 1244.1 82.0686 1244.1 82.4C1244.1 82.7314 1244.37 83 1244.7 83C1245.03 83 1245.3 82.7314 1245.3 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.2 82.4C1231.2 82.0686 1230.93 81.8 1230.6 81.8C1230.27 81.8 1230 82.0686 1230 82.4C1230 82.7314 1230.27 83 1230.6 83C1230.93 83 1231.2 82.7314 1231.2 82.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.8 70.4C1426.8 70.1 1427.1 69.8 1427.4 69.8C1427.7 69.8 1428 70.1 1428 70.4C1428 70.7 1427.7 71 1427.4 71C1427 71 1426.8 70.7 1426.8 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.9 70.4C1413.9 70.0686 1413.63 69.8 1413.3 69.8C1412.97 69.8 1412.7 70.0686 1412.7 70.4C1412.7 70.7314 1412.97 71 1413.3 71C1413.63 71 1413.9 70.7314 1413.9 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.9 70.4C1399.9 70.0686 1399.63 69.8 1399.3 69.8C1398.97 69.8 1398.7 70.0686 1398.7 70.4C1398.7 70.7314 1398.97 71 1399.3 71C1399.63 71 1399.9 70.7314 1399.9 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.8 70.4C1385.8 70.0686 1385.53 69.8 1385.2 69.8C1384.87 69.8 1384.6 70.0686 1384.6 70.4C1384.6 70.7314 1384.87 71 1385.2 71C1385.53 71 1385.8 70.7314 1385.8 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.7 70.4C1371.7 70.0686 1371.43 69.8 1371.1 69.8C1370.77 69.8 1370.5 70.0686 1370.5 70.4C1370.5 70.7314 1370.77 71 1371.1 71C1371.43 71 1371.7 70.7314 1371.7 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.7 70.4C1357.7 70.0686 1357.43 69.8 1357.1 69.8C1356.77 69.8 1356.5 70.0686 1356.5 70.4C1356.5 70.7314 1356.77 71 1357.1 71C1357.43 71 1357.7 70.7314 1357.7 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.6 70.4C1343.6 70.0686 1343.33 69.8 1343 69.8C1342.67 69.8 1342.4 70.0686 1342.4 70.4C1342.4 70.7314 1342.67 71 1343 71C1343.33 71 1343.6 70.7314 1343.6 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.4 70.4C1328.4 70.1 1328.7 69.8 1329 69.8C1329.3 69.8 1329.6 70.1 1329.6 70.4C1329.6 70.7 1329.3 71 1329 71C1328.7 71 1328.4 70.7 1328.4 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.5 70.4C1315.5 70.0686 1315.23 69.8 1314.9 69.8C1314.57 69.8 1314.3 70.0686 1314.3 70.4C1314.3 70.7314 1314.57 71 1314.9 71C1315.23 71 1315.5 70.7314 1315.5 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.3 70.4C1300.3 70.1 1300.6 69.8 1300.9 69.8C1301.2 69.8 1301.5 70.1 1301.5 70.4C1301.5 70.7 1301.2 71 1300.9 71C1300.6 71 1300.3 70.7 1300.3 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.4 70.4C1287.4 70.0686 1287.13 69.8 1286.8 69.8C1286.47 69.8 1286.2 70.0686 1286.2 70.4C1286.2 70.7314 1286.47 71 1286.8 71C1287.13 71 1287.4 70.7314 1287.4 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.4 70.4C1273.4 70.0686 1273.13 69.8 1272.8 69.8C1272.47 69.8 1272.2 70.0686 1272.2 70.4C1272.2 70.7314 1272.47 71 1272.8 71C1273.13 71 1273.4 70.7314 1273.4 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.3 70.4C1259.3 70.0686 1259.03 69.8 1258.7 69.8C1258.37 69.8 1258.1 70.0686 1258.1 70.4C1258.1 70.7314 1258.37 71 1258.7 71C1259.03 71 1259.3 70.7314 1259.3 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.3 70.4C1245.3 70.0686 1245.03 69.8 1244.7 69.8C1244.37 69.8 1244.1 70.0686 1244.1 70.4C1244.1 70.7314 1244.37 71 1244.7 71C1245.03 71 1245.3 70.7314 1245.3 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.2 70.4C1231.2 70.0686 1230.93 69.8 1230.6 69.8C1230.27 69.8 1230 70.0686 1230 70.4C1230 70.7314 1230.27 71 1230.6 71C1230.93 71 1231.2 70.7314 1231.2 70.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.8 58.4C1426.8 58.1 1427.1 57.8 1427.4 57.8C1427.7 57.8 1428 58.1 1428 58.4C1428 58.7 1427.7 59 1427.4 59C1427 59 1426.8 58.7 1426.8 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.9 58.4C1413.9 58.0686 1413.63 57.8 1413.3 57.8C1412.97 57.8 1412.7 58.0686 1412.7 58.4C1412.7 58.7314 1412.97 59 1413.3 59C1413.63 59 1413.9 58.7314 1413.9 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.9 58.4C1399.9 58.0686 1399.63 57.8 1399.3 57.8C1398.97 57.8 1398.7 58.0686 1398.7 58.4C1398.7 58.7314 1398.97 59 1399.3 59C1399.63 59 1399.9 58.7314 1399.9 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.8 58.4C1385.8 58.0686 1385.53 57.8 1385.2 57.8C1384.87 57.8 1384.6 58.0686 1384.6 58.4C1384.6 58.7314 1384.87 59 1385.2 59C1385.53 59 1385.8 58.7314 1385.8 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.7 58.4C1371.7 58.0686 1371.43 57.8 1371.1 57.8C1370.77 57.8 1370.5 58.0686 1370.5 58.4C1370.5 58.7314 1370.77 59 1371.1 59C1371.43 59 1371.7 58.7314 1371.7 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.7 58.4C1357.7 58.0686 1357.43 57.8 1357.1 57.8C1356.77 57.8 1356.5 58.0686 1356.5 58.4C1356.5 58.7314 1356.77 59 1357.1 59C1357.43 59 1357.7 58.7314 1357.7 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.6 58.4C1343.6 58.0686 1343.33 57.8 1343 57.8C1342.67 57.8 1342.4 58.0686 1342.4 58.4C1342.4 58.7314 1342.67 59 1343 59C1343.33 59 1343.6 58.7314 1343.6 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.4 58.4C1328.4 58.1 1328.7 57.8 1329 57.8C1329.3 57.8 1329.6 58.1 1329.6 58.4C1329.6 58.7 1329.3 59 1329 59C1328.7 59 1328.4 58.7 1328.4 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.5 58.4C1315.5 58.0686 1315.23 57.8 1314.9 57.8C1314.57 57.8 1314.3 58.0686 1314.3 58.4C1314.3 58.7314 1314.57 59 1314.9 59C1315.23 59 1315.5 58.7314 1315.5 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.3 58.4C1300.3 58.1 1300.6 57.8 1300.9 57.8C1301.2 57.8 1301.5 58.1 1301.5 58.4C1301.5 58.7 1301.2 59 1300.9 59C1300.6 59 1300.3 58.7 1300.3 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.4 58.4C1287.4 58.0686 1287.13 57.8 1286.8 57.8C1286.47 57.8 1286.2 58.0686 1286.2 58.4C1286.2 58.7314 1286.47 59 1286.8 59C1287.13 59 1287.4 58.7314 1287.4 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.4 58.4C1273.4 58.0686 1273.13 57.8 1272.8 57.8C1272.47 57.8 1272.2 58.0686 1272.2 58.4C1272.2 58.7314 1272.47 59 1272.8 59C1273.13 59 1273.4 58.7314 1273.4 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.3 58.4C1259.3 58.0686 1259.03 57.8 1258.7 57.8C1258.37 57.8 1258.1 58.0686 1258.1 58.4C1258.1 58.7314 1258.37 59 1258.7 59C1259.03 59 1259.3 58.7314 1259.3 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.3 58.4C1245.3 58.0686 1245.03 57.8 1244.7 57.8C1244.37 57.8 1244.1 58.0686 1244.1 58.4C1244.1 58.7314 1244.37 59 1244.7 59C1245.03 59 1245.3 58.7314 1245.3 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.2 58.4C1231.2 58.0686 1230.93 57.8 1230.6 57.8C1230.27 57.8 1230 58.0686 1230 58.4C1230 58.7314 1230.27 59 1230.6 59C1230.93 59 1231.2 58.7314 1231.2 58.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.8 46.4C1426.8 46.1 1427.1 45.8 1427.4 45.8C1427.7 45.8 1428 46.1 1428 46.4C1428 46.7 1427.7 47 1427.4 47C1427 47 1426.8 46.7 1426.8 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.7 46.4C1412.7 46.1 1413 45.8 1413.3 45.8C1413.6 45.8 1413.9 46.1 1413.9 46.4C1413.9 46.7 1413.6 47 1413.3 47C1413 47 1412.7 46.7 1412.7 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.6 46.4C1398.6 46.1 1398.9 45.8 1399.2 45.8C1399.5 45.8 1399.8 46.1 1399.8 46.4C1399.8 46.7 1399.5 47 1399.2 47C1398.9 47 1398.6 46.7 1398.6 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.6 46.4C1384.6 46.1 1384.9 45.8 1385.2 45.8C1385.5 45.8 1385.8 46.1 1385.8 46.4C1385.8 46.7 1385.5 47 1385.2 47C1384.9 47 1384.6 46.7 1384.6 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.5 46.4C1370.5 46.1 1370.8 45.8 1371.1 45.8C1371.4 45.8 1371.7 46.1 1371.7 46.4C1371.7 46.7 1371.4 47 1371.1 47C1370.8 47 1370.5 46.7 1370.5 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.5 46.4C1356.5 46.1 1356.8 45.8 1357.1 45.8C1357.4 45.8 1357.7 46.1 1357.7 46.4C1357.7 46.7 1357.4 47 1357.1 47C1356.8 47 1356.5 46.7 1356.5 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.4 46.4C1342.4 46.1 1342.7 45.8 1343 45.8C1343.3 45.8 1343.6 46.1 1343.6 46.4C1343.6 46.7 1343.3 47 1343 47C1342.7 47 1342.4 46.7 1342.4 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.4 46.4C1328.4 46.1 1328.7 45.8 1329 45.8C1329.3 45.8 1329.6 46.1 1329.6 46.4C1329.6 46.7 1329.3 47 1329 47C1328.7 47 1328.4 46.7 1328.4 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.3 46.4C1314.3 46.1 1314.6 45.8 1314.9 45.8C1315.2 45.8 1315.5 46.1 1315.5 46.4C1315.5 46.7 1315.2 47 1314.9 47C1314.6 47 1314.3 46.7 1314.3 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.3 46.4C1300.3 46.1 1300.6 45.8 1300.9 45.8C1301.2 45.8 1301.5 46.1 1301.5 46.4C1301.5 46.7 1301.2 47 1300.9 47C1300.6 47 1300.3 46.7 1300.3 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.2 46.4C1286.2 46.1 1286.5 45.8 1286.8 45.8C1287.1 45.8 1287.4 46.1 1287.4 46.4C1287.4 46.7 1287.1 47 1286.8 47C1286.5 47 1286.2 46.7 1286.2 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.2 46.4C1272.2 46.1 1272.5 45.8 1272.8 45.8C1273.1 45.8 1273.4 46.1 1273.4 46.4C1273.4 46.7 1273.1 47 1272.8 47C1272.4 47 1272.2 46.7 1272.2 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.1 46.4C1258.1 46.1 1258.4 45.8 1258.7 45.8C1259 45.8 1259.3 46.1 1259.3 46.4C1259.3 46.7 1259 47 1258.7 47C1258.4 47 1258.1 46.7 1258.1 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.1 46.4C1244.1 46.1 1244.4 45.8 1244.7 45.8C1245 45.8 1245.3 46.1 1245.3 46.4C1245.3 46.7 1245 47 1244.7 47C1244.3 47 1244.1 46.7 1244.1 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 46.4C1230 46.1 1230.3 45.8 1230.6 45.8C1230.9 45.8 1231.2 46.1 1231.2 46.4C1231.2 46.7 1230.9 47 1230.6 47C1230.3 47 1230 46.7 1230 46.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.8 34.4C1426.8 34.1 1427.1 33.8 1427.4 33.8C1427.7 33.8 1428 34.1 1428 34.4C1428 34.7 1427.7 35 1427.4 35C1427 35 1426.8 34.7 1426.8 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.7 34.4C1412.7 34.1 1413 33.8 1413.3 33.8C1413.6 33.8 1413.9 34.1 1413.9 34.4C1413.9 34.7 1413.6 35 1413.3 35C1413 35 1412.7 34.7 1412.7 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.6 34.4C1398.6 34.1 1398.9 33.8 1399.2 33.8C1399.5 33.8 1399.8 34.1 1399.8 34.4C1399.8 34.7 1399.5 35 1399.2 35C1398.9 35 1398.6 34.7 1398.6 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.6 34.4C1384.6 34.1 1384.9 33.8 1385.2 33.8C1385.5 33.8 1385.8 34.1 1385.8 34.4C1385.8 34.7 1385.5 35 1385.2 35C1384.9 35 1384.6 34.7 1384.6 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.5 34.4C1370.5 34.1 1370.8 33.8 1371.1 33.8C1371.4 33.8 1371.7 34.1 1371.7 34.4C1371.7 34.7 1371.4 35 1371.1 35C1370.8 35 1370.5 34.7 1370.5 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.5 34.4C1356.5 34.1 1356.8 33.8 1357.1 33.8C1357.4 33.8 1357.7 34.1 1357.7 34.4C1357.7 34.7 1357.4 35 1357.1 35C1356.8 35 1356.5 34.7 1356.5 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.4 34.4C1342.4 34.1 1342.7 33.8 1343 33.8C1343.3 33.8 1343.6 34.1 1343.6 34.4C1343.6 34.7 1343.3 35 1343 35C1342.7 35 1342.4 34.7 1342.4 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.4 34.4C1328.4 34.1 1328.7 33.8 1329 33.8C1329.3 33.8 1329.6 34.1 1329.6 34.4C1329.6 34.7 1329.3 35 1329 35C1328.7 35 1328.4 34.7 1328.4 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.3 34.4C1314.3 34.1 1314.6 33.8 1314.9 33.8C1315.2 33.8 1315.5 34.1 1315.5 34.4C1315.5 34.7 1315.2 35 1314.9 35C1314.6 35 1314.3 34.7 1314.3 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.3 34.4C1300.3 34.1 1300.6 33.8 1300.9 33.8C1301.2 33.8 1301.5 34.1 1301.5 34.4C1301.5 34.7 1301.2 35 1300.9 35C1300.6 35 1300.3 34.7 1300.3 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.2 34.4C1286.2 34.1 1286.5 33.8 1286.8 33.8C1287.1 33.8 1287.4 34.1 1287.4 34.4C1287.4 34.7 1287.1 35 1286.8 35C1286.5 35 1286.2 34.7 1286.2 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.2 34.4C1272.2 34.1 1272.5 33.8 1272.8 33.8C1273.1 33.8 1273.4 34.1 1273.4 34.4C1273.4 34.7 1273.1 35 1272.8 35C1272.4 35 1272.2 34.7 1272.2 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.1 34.4C1258.1 34.1 1258.4 33.8 1258.7 33.8C1259 33.8 1259.3 34.1 1259.3 34.4C1259.3 34.7 1259 35 1258.7 35C1258.4 35 1258.1 34.7 1258.1 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.1 34.4C1244.1 34.1 1244.4 33.8 1244.7 33.8C1245 33.8 1245.3 34.1 1245.3 34.4C1245.3 34.7 1245 35 1244.7 35C1244.3 35 1244.1 34.7 1244.1 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 34.4C1230 34.1 1230.3 33.8 1230.6 33.8C1230.9 33.8 1231.2 34.1 1231.2 34.4C1231.2 34.7 1230.9 35 1230.6 35C1230.3 35 1230 34.7 1230 34.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.8 22.4C1426.8 22.1 1427.1 21.8 1427.4 21.8C1427.7 21.8 1428 22.1 1428 22.4C1428 22.7 1427.7 23 1427.4 23C1427 23 1426.8 22.7 1426.8 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.7 22.4C1412.7 22.1 1413 21.8 1413.3 21.8C1413.6 21.8 1413.9 22.1 1413.9 22.4C1413.9 22.7 1413.6 23 1413.3 23C1413 23 1412.7 22.7 1412.7 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.6 22.4C1398.6 22.1 1398.9 21.8 1399.2 21.8C1399.5 21.8 1399.8 22.1 1399.8 22.4C1399.8 22.7 1399.5 23 1399.2 23C1398.9 23 1398.6 22.7 1398.6 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.6 22.4C1384.6 22.1 1384.9 21.8 1385.2 21.8C1385.5 21.8 1385.8 22.1 1385.8 22.4C1385.8 22.7 1385.5 23 1385.2 23C1384.9 23 1384.6 22.7 1384.6 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.5 22.4C1370.5 22.1 1370.8 21.8 1371.1 21.8C1371.4 21.8 1371.7 22.1 1371.7 22.4C1371.7 22.7 1371.4 23 1371.1 23C1370.8 23 1370.5 22.7 1370.5 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.5 22.4C1356.5 22.1 1356.8 21.8 1357.1 21.8C1357.4 21.8 1357.7 22.1 1357.7 22.4C1357.7 22.7 1357.4 23 1357.1 23C1356.8 23 1356.5 22.7 1356.5 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.4 22.4C1342.4 22.1 1342.7 21.8 1343 21.8C1343.3 21.8 1343.6 22.1 1343.6 22.4C1343.6 22.7 1343.3 23 1343 23C1342.7 23 1342.4 22.7 1342.4 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.4 22.4C1328.4 22.1 1328.7 21.8 1329 21.8C1329.3 21.8 1329.6 22.1 1329.6 22.4C1329.6 22.7 1329.3 23 1329 23C1328.7 23 1328.4 22.7 1328.4 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.3 22.4C1314.3 22.1 1314.6 21.8 1314.9 21.8C1315.2 21.8 1315.5 22.1 1315.5 22.4C1315.5 22.7 1315.2 23 1314.9 23C1314.6 23 1314.3 22.7 1314.3 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.3 22.4C1300.3 22.1 1300.6 21.8 1300.9 21.8C1301.2 21.8 1301.5 22.1 1301.5 22.4C1301.5 22.7 1301.2 23 1300.9 23C1300.6 23 1300.3 22.7 1300.3 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.2 22.4C1286.2 22.1 1286.5 21.8 1286.8 21.8C1287.1 21.8 1287.4 22.1 1287.4 22.4C1287.4 22.7 1287.1 23 1286.8 23C1286.5 23 1286.2 22.7 1286.2 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.2 22.4C1272.2 22.1 1272.5 21.8 1272.8 21.8C1273.1 21.8 1273.4 22.1 1273.4 22.4C1273.4 22.7 1273.1 23 1272.8 23C1272.4 23 1272.2 22.7 1272.2 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.1 22.4C1258.1 22.1 1258.4 21.8 1258.7 21.8C1259 21.8 1259.3 22.1 1259.3 22.4C1259.3 22.7 1259 23 1258.7 23C1258.4 23 1258.1 22.7 1258.1 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.1 22.4C1244.1 22.1 1244.4 21.8 1244.7 21.8C1245 21.8 1245.3 22.1 1245.3 22.4C1245.3 22.7 1245 23 1244.7 23C1244.3 23 1244.1 22.7 1244.1 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 22.4C1230 22.1 1230.3 21.8 1230.6 21.8C1230.9 21.8 1231.2 22.1 1231.2 22.4C1231.2 22.7 1230.9 23 1230.6 23C1230.3 23 1230 22.7 1230 22.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.8 10.4C1426.8 10.1 1427.1 9.8 1427.4 9.8C1427.7 9.8 1428 10.1 1428 10.4C1428 10.7 1427.7 11 1427.4 11C1427 11 1426.8 10.7 1426.8 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.9 10.4C1413.9 10.0686 1413.63 9.8 1413.3 9.8C1412.97 9.8 1412.7 10.0686 1412.7 10.4C1412.7 10.7314 1412.97 11 1413.3 11C1413.63 11 1413.9 10.7314 1413.9 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.9 10.4C1399.9 10.0686 1399.63 9.8 1399.3 9.8C1398.97 9.8 1398.7 10.0686 1398.7 10.4C1398.7 10.7314 1398.97 11 1399.3 11C1399.63 11 1399.9 10.7314 1399.9 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.8 10.4C1385.8 10.0686 1385.53 9.8 1385.2 9.8C1384.87 9.8 1384.6 10.0686 1384.6 10.4C1384.6 10.7314 1384.87 11 1385.2 11C1385.53 11 1385.8 10.7314 1385.8 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.7 10.4C1371.7 10.0686 1371.43 9.8 1371.1 9.8C1370.77 9.8 1370.5 10.0686 1370.5 10.4C1370.5 10.7314 1370.77 11 1371.1 11C1371.43 11 1371.7 10.7314 1371.7 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.7 10.4C1357.7 10.0686 1357.43 9.8 1357.1 9.8C1356.77 9.8 1356.5 10.0686 1356.5 10.4C1356.5 10.7314 1356.77 11 1357.1 11C1357.43 11 1357.7 10.7314 1357.7 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.6 10.4C1343.6 10.0686 1343.33 9.8 1343 9.8C1342.67 9.8 1342.4 10.0686 1342.4 10.4C1342.4 10.7314 1342.67 11 1343 11C1343.33 11 1343.6 10.7314 1343.6 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.4 10.4C1328.4 10.1 1328.7 9.8 1329 9.8C1329.3 9.8 1329.6 10.1 1329.6 10.4C1329.6 10.7 1329.3 11 1329 11C1328.7 11 1328.4 10.7 1328.4 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.5 10.4C1315.5 10.0686 1315.23 9.8 1314.9 9.8C1314.57 9.8 1314.3 10.0686 1314.3 10.4C1314.3 10.7314 1314.57 11 1314.9 11C1315.23 11 1315.5 10.7314 1315.5 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.3 10.4C1300.3 10.1 1300.6 9.8 1300.9 9.8C1301.2 9.8 1301.5 10.1 1301.5 10.4C1301.5 10.7 1301.2 11 1300.9 11C1300.6 11 1300.3 10.7 1300.3 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.4 10.4C1287.4 10.0686 1287.13 9.8 1286.8 9.8C1286.47 9.8 1286.2 10.0686 1286.2 10.4C1286.2 10.7314 1286.47 11 1286.8 11C1287.13 11 1287.4 10.7314 1287.4 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.4 10.4C1273.4 10.0686 1273.13 9.8 1272.8 9.8C1272.47 9.8 1272.2 10.0686 1272.2 10.4C1272.2 10.7314 1272.47 11 1272.8 11C1273.13 11 1273.4 10.7314 1273.4 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.3 10.4C1259.3 10.0686 1259.03 9.8 1258.7 9.8C1258.37 9.8 1258.1 10.0686 1258.1 10.4C1258.1 10.7314 1258.37 11 1258.7 11C1259.03 11 1259.3 10.7314 1259.3 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.3 10.4C1245.3 10.0686 1245.03 9.8 1244.7 9.8C1244.37 9.8 1244.1 10.0686 1244.1 10.4C1244.1 10.7314 1244.37 11 1244.7 11C1245.03 11 1245.3 10.7314 1245.3 10.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.2 10.4C1231.2 10.0686 1230.93 9.8 1230.6 9.8C1230.27 9.8 1230 10.0686 1230 10.4C1230 10.7314 1230.27 11 1230.6 11C1230.93 11 1231.2 10.7314 1231.2 10.4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_25521",
    x1: 1086.7,
    y1: 200.886,
    x2: 198.314,
    y2: 1208.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00127704,
    stopColor: "#2537A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CEAB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_25521",
    x1: 1086.7,
    y1: 200.886,
    x2: 198.314,
    y2: 1208.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00127704,
    stopColor: "#2537A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CEAB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15_25521",
    x1: 1086.7,
    y1: 200.886,
    x2: 198.314,
    y2: 1208.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00127704,
    stopColor: "#2537A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CEAB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15_25521",
    x1: 1086.7,
    y1: 200.886,
    x2: 198.314,
    y2: 1208.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00127704,
    stopColor: "#2537A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CEAB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15_25521",
    x1: 299,
    y1: 60,
    x2: 299,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2537A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2537A8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_25521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 796,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15_25521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5,
    height: 28,
    fill: "white",
    transform: "translate(697 69)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_15_25521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 30,
    fill: "white",
    transform: "translate(1215 169)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_15_25521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(699 692)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_15_25521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 28,
    fill: "white",
    transform: "translate(974 384)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_15_25521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5,
    height: 30,
    fill: "white",
    transform: "translate(1150 653)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_15_25521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.89,
    height: 35.89,
    fill: "white",
    transform: "translate(105 456)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_15_25521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.75,
    height: 30,
    fill: "white",
    transform: "translate(286 693)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogin);
export default __webpack_public_path__ + "static/media/bg-login.ab47e672fca4b58664cde27868127927.svg";
export { ForwardRef as ReactComponent };